import { createAsyncThunk } from "@reduxjs/toolkit";
import{
    searchCaseDocuments
} from "../../../api/caseDocuments_api";


export const searchCaseDocumentsAction = createAsyncThunk(
  "caseDocuments/searchCaseDocuments",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await searchCaseDocuments(payload);
      return result;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to search documents");
    }
  },
);